import React from 'react';
import Link from 'next/link';
import * as S from '../styled';
import * as ST from './styled';
import { sectionData } from './section-data';

const renderList = () => {
    return (
        sectionData.map(({ id, title, text, src, href, hrefText }) => (
            <ST.ListItem key={id}>
                <ST.ImgWrap>
                    <S.Img src={`/static/images/domru-internet/${src}`} alt='' />
                </ST.ImgWrap>
                <ST.DataTitle>{title}</ST.DataTitle>
                <ST.DataText>{text}</ST.DataText>
                <Link href={href} passHref prefetch={false}>
                    <ST.DataLink>{hrefText}</ST.DataLink>
                </Link>
            </ST.ListItem>
        ))
    );
};

export const Opportunities = () => {
    return (
        <S.Section bgColor='#fff'>
            <S.InnerContainer>
                <S.SectionTitle>Дополнительные возможности</S.SectionTitle>
                <ST.List>
                    {renderList()}
                </ST.List>
            </S.InnerContainer>
        </S.Section>
    );
};
